/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AuditLog,
    AuditLogFromJSON,
    AuditLogFromJSONTyped,
    AuditLogToJSON,
} from './';

/**
 * 
 * @export
 * @interface AcquiringAuditLogsListResponse
 */
export interface AcquiringAuditLogsListResponse {
    /**
     * 
     * @type {Array<AuditLog>}
     * @memberof AcquiringAuditLogsListResponse
     */
    logList?: Array<AuditLog>;
}

export function AcquiringAuditLogsListResponseFromJSON(json: any): AcquiringAuditLogsListResponse {
    return AcquiringAuditLogsListResponseFromJSONTyped(json, false);
}

export function AcquiringAuditLogsListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AcquiringAuditLogsListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'logList': !exists(json, 'logList') ? undefined : ((json['logList'] as Array<any>).map(AuditLogFromJSON)),
    };
}

export function AcquiringAuditLogsListResponseToJSON(value?: AcquiringAuditLogsListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'logList': value.logList === undefined ? undefined : ((value.logList as Array<any>).map(AuditLogToJSON)),
    };
}


